
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.06 4.363a1.2 1.2 0 010 1.697 8.4 8.4 0 000 11.88 1.2 1.2 0 01-1.697 1.697C.146 15.419.146 8.58 4.363 4.363a1.2 1.2 0 011.697 0zm11.88 0a1.2 1.2 0 011.697 0c4.218 4.218 4.218 11.056 0 15.274a1.2 1.2 0 11-1.697-1.697 8.4 8.4 0 000-11.88 1.2 1.2 0 010-1.697zM9.455 7.757a1.2 1.2 0 010 1.697 3.6 3.6 0 000 5.091 1.2 1.2 0 11-1.697 1.697 6 6 0 010-8.485 1.2 1.2 0 011.697 0zm5.09 0a1.2 1.2 0 011.698 0 6 6 0 010 8.486 1.2 1.2 0 01-1.697-1.697 3.6 3.6 0 000-5.092 1.2 1.2 0 010-1.697zM12 10.8a1.2 1.2 0 011.2 1.2v.012a1.2 1.2 0 01-2.4 0V12a1.2 1.2 0 011.2-1.2z","fill":"#fff"}})])
          )
        }
      }
    